import React from 'react';

const FormContainer = ({ children }) => {
  return <div className="form-container">{children}</div>;
};

export default FormContainer;